import React, { Component } from "react";
import { Form, Col, Container, Row, Button } from 'react-bootstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import MainPagesLayout from '../../PageLayout/MainPagesLayout/MainPagesLayout.jsx';
import Loading from '../../PageLayout/Loading';
import apiService from '../../Services/ApiService';
import ClassicTitledTile from './component/ClassicTitledTile';
import UserService from '../../Services/UserService';
import TagListEditor from './component/TagListEditor';
import ApiService from '../../Services/ApiService';
import ProjectRequestService from '../../Services/ProjectRequestService';
import Spinner from '../../PageLayout/Spinner';
import AuthorizeService from '../../ApiAuthorization/AuthorizeService';
import RouterHistory from '../../Router/RouterHistory';
import UserListEditor from './component/UserListEditor';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

class ProjectRequestCreationPage extends Component {
  static propTypes = {
    match: ReactRouterPropTypes.match,
  }

  constructor() {
    super();

    this.teamMemberUpnInput = React.createRef();
    this.teamMemberRoleInput = React.createRef();
    this.formDomNode = React.createRef();

    this.buttonTextCreate = 'Create request';
    this.buttonTextUpdate = 'Update request';
    this.buttonTextValidate = 'Validate';
    this.buttonTextCancel = 'Cancel';

    // 'Admin / Owner',
    this.state = {
      isLoading: true,
      formValidated: false,
      isUserAdmin: false,
      isUserDataScientist: false,
      availableCostCenters: [],
      availableTags: [],
      availableRoles: [],
      availableTemplates: [],
      selectedTeamMemberUpnInput: -1,
      selectedTeamMemberRoleInput: -1,
      currentUser: null,
      invalidShortNameInput: false,
      buttonTextCreate: this.buttonTextCreate,
      buttonTextUpdate: this.buttonTextUpdate,
      buttonTextValidate: this.buttonTextValidate,
      buttonTextCancel: this.buttonTextCancel,

      projectCreationRequest: {
        "projectCreationRequestId": 0, // Important keep at zero at creation
        "name": "",
        "shortName": "",
        "private": false,
        "description": "",
        "costcenterRefId": "",
        "projectTemplateRefId": "",
        "projectCreationRequestStatusId": "REQUESTED",
        "createdAt": "",
        "createdBy": "", // user upn
        "updatedAt": null,
        "updatedBy": null,
        "isActive": true,
        "enableWebApp": false,
        "enableDocumentation": false,
        "restrictAccessWebApp": false,
        "restrictAccessDocumentation": false,
        "projectCreationRequestTags": [],
        "projectCreationRequestUsers": []
      }
    };
  }
  componentDidMount() {
    const requestId = this.props.match?.params?.requestId;
    const apiRequest = [
      UserService.IsUserAdmin(),
      UserService.IsUserDataScientist(),
      ApiService.getRef(),
      AuthorizeService.getUser()
    ];

    if (requestId) {
      apiRequest.push(ApiService.getCreateProjectRequest(requestId));
    }

    Promise.all(apiRequest).then((data) => {
      var request = (requestId) ?
        this.apiRequestPreprocesor(data[4], data[2].profileTypeRefs)
        :
        {
          ...this.state.projectCreationRequest,
          projectTemplateRefId: data[2].projectTemplateRefs[0].projectTemplateRefId,
          projectCreationRequestUsers: [
            {
              "profileTypeRefId": "ADMIN",
              "user": {
                "upn": data[3].preferred_username,
                "firstName": data[3].name.substr(data[3].name.indexOf(', ') + 2), //
                "lastName": data[3].name.substr(0, data[3].name.indexOf(', ')), //
                "mail": data[3].email, //
              }
            }
          ]
        };
        console.log(data);
      let stateUpdate = {
        isUserAdmin: data[0],
        isUserDataScientist: data[1],
        availableCostCenters: data[2].costcenterRefs.sort((cc, bb) => cc.displayOrder - bb.displayOrder).map(c => ({
          value: c.costcenterRefId,
          displayName: c.costcenterRefDescription
        })),
        availableRoles: data[2].profileTypeRefs,
        availableTemplates: data[2].projectTemplateRefs,
        currentUser: data[3],
        availableTags: data[2].tagRefs,
        projectCreationRequest: request,
        isLoading: false
      };
      this.setState(() => stateUpdate);
    });
  }

  componentDidUpdate() {
    if (this.teamMemberUpnInput && this.teamMemberUpnInput.current) {
      this.teamMemberUpnInput.current.focus();
    }
    if (this.teamMemberRoleInput && this.teamMemberRoleInput.current) {
      this.teamMemberRoleInput.current.focus();
    }
  }

  apiRequestPreprocesor(request, roles) {
    return ({
      ...request,
      projectCreationRequestUsers: request.projectCreationRequestUsers.sort((a, b) =>
        roles.findIndex((role) => role.value === a.profileTypeRefId) - roles.findIndex((role) => role.value === b.profileTypeRefId)
      ),
    });
  }

  validateShortName = (shortName) => {
    const regex = /^[a-z-]{0,12}$/gm;
    const r = regex.exec(shortName);

    return r && r.length === 1 && r[0] === shortName;
  }

  isButtonActionPending = (buttonId) => {
    const buttonSysIdPending = `buttonActionPending${buttonId}`;

    return !!this.state[buttonSysIdPending];
  }

  updateSubmitButtonStatus = (buttonId, buttonState) => {
    const buttonSysId = `buttonText${buttonId}`;
    const buttonSysIdPending = `buttonActionPending${buttonId}`;
    let content = this[buttonSysId];
    let state = {};

    switch (buttonState) {
      case 'pending':
        state[buttonSysId] = <span>{content} <Spinner /></span>;
        state[buttonSysIdPending] = true;
        break;
      case 'success':
        state[buttonSysId] = <span>{content} <i className="icon-circle-checked" /></span>;
        //state[buttonSysIdPending] = false;
        setTimeout(() => { RouterHistory.push('/'); }, 2500);
        break;
      case 'error':
        state[buttonSysId] = <span>{content} <i className="icon-circle-x" /></span>;
        state[buttonSysIdPending] = false;
        break;
      default:
        break;
    }

    this.setState(state);
  }

  updateProjectCreationRequest = (field, value) => {
    var a = this.state;
    if (field === 'shortName' && !this.validateShortName(value)) {
      this.setState({ invalidShortNameInput: true }, () => {
        setTimeout(() => this.setState({ invalidShortNameInput: false }), 2000);
      });
      return;
    }

    if (field === 'private' && value === true) {
      a.projectCreationRequest['isPublic'] = false;
    }

    a.projectCreationRequest[field] = value;
    this.setState(a);
  }

  createProjectRequest = () => {
    if (this.isButtonActionPending('Create')) {
      return;
    }

    var request = {
      name: this.state.projectCreationRequest.name,
      private: this.state.projectCreationRequest.private,
      shortName: this.state.projectCreationRequest.shortName,
      projectCreationRequestStatusId: this.state.projectCreationRequest.projectCreationRequestStatusId,
      costcenterRefId: this.state.projectCreationRequest.costcenterRefId,
      projectTemplateRefId: this.state.projectCreationRequest.projectTemplateRefId,
      description: this.state.projectCreationRequest.description,
      isPublic:this.state.projectCreationRequest.isPublic,
      enableWebApp: this.state.projectCreationRequest.enableWebApp,
      enableDocumentation: this.state.projectCreationRequest.enableDocumentation,
      restrictAccessWebApp: this.state.projectCreationRequest.restrictAccessWebApp,
      restrictAccessDocumentation: this.state.projectCreationRequest.restrictAccessDocumentation,
      projectCreationRequestTags: this.state.projectCreationRequest.projectCreationRequestTags.map((tag) => ({
        tagId: tag.tagId
      })),
      projectCreationRequestUsers: this.state.projectCreationRequest.projectCreationRequestUsers.map((user) => ({
        "profileTypeRefId": user.profileTypeRefId,
        "user": {
          "mail": user.user.mail
        }
      }))
    };

    this.updateSubmitButtonStatus('Create', 'pending');
    apiService.createCreateProjectRequest(request)
      .then((request) => {
        this.updateSubmitButtonStatus('Create', 'success');
        this.setState({ projectCreationRequest: this.apiRequestPreprocesor(request, this.state.availableRoles) });
      })
      .catch(() => {
        this.updateSubmitButtonStatus('Create', 'error');
      });
  }

  updateProjectRequest = () => {
    if (this.state.projectCreationRequest.projectCreationRequestStatusId === 'REQUESTED' &&
      !this.isButtonActionPending('Update')) {
      this.updateSubmitButtonStatus('Update', 'pending');
      apiService.updateCreateProjectRequest(this.state.projectCreationRequest)
        .then(() => {
          this.updateSubmitButtonStatus('Update', 'success');
        })
        .catch(() => {
          this.updateSubmitButtonStatus('Update', 'error');
        });
    }
  }

  onTagChange = (selectedTags) => {
    this.setState({
      projectCreationRequest: {
        ...this.state.projectCreationRequest,
        projectCreationRequestTags: selectedTags
      }
    });
  }

  validateProjectRequest = () => {
    if (this.isButtonActionPending('Validate')) {
      return;
    }

    this.updateSubmitButtonStatus('Validate', 'pending');
    apiService.updateCreateProjectRequest({ ...this.state.projectCreationRequest, projectCreationRequestStatusId: 'ACCEPTED' })
      .then((request) => {
        this.updateSubmitButtonStatus('Validate', 'success');
        this.setState({
          projectCreationRequest: this.apiRequestPreprocesor(request, this.state.availableRoles),
        });
      })
      .catch(() => {
        this.updateSubmitButtonStatus('Validate', 'error');
      });
  }

  cancelProjectCreationRequest = () => {
    if (this.isButtonActionPending('Cancel')) {
      return;
    }
    if (this.state.projectCreationRequest.projectCreationRequestStatusId != 'REQUESTED' ||
      this.state.projectCreationRequest.projectCreationRequestId === 0) {
      RouterHistory.push('/');
    }

    ProjectRequestService.cancelRequest(this.state.projectCreationRequest,
      () => {
        this.updateSubmitButtonStatus('Cancel', 'pending');
        this.setState({
          projectCreationRequest: {
            ...this.state.projectCreationRequest,
            projectCreationRequestStatus: {
              ...this.state.projectCreationRequest.projectCreationRequestStatus,
              projectCreationRequestStatusDescription: 'Request cancelled',
            },
            projectCreationRequestStatusId: 'CANCELLED',
          },
        });
      },
      () => {
        this.updateSubmitButtonStatus('Cancel', 'success');
        setTimeout(() => RouterHistory.push('/'), 2500);
      }
    );
  }

  handleSubmit = (event) => {
    const form = event.currentTarget;

    if (form.checkValidity() === true &&
      this.state.projectCreationRequest.projectCreationRequestTags.length > 0 &&
      this.usersListEditorRef.validateSelection()) {
      if (this.state.projectCreationRequest.projectCreationRequestId === 0) {
        this.createProjectRequest();
      } else {
        this.updateProjectRequest();
      }
    }
    if (!this.state.formValidated) {
      this.setState(() => ({ formValidated: true }));
    }

    event.preventDefault();
    event.stopPropagation();
  };

  updateMember = (u) => {
    this.setState({
      projectCreationRequest: { ...this.state.projectCreationRequest, projectCreationRequestUsers: u }
    });
  }

  render() {
    const readOnly = this.state.projectCreationRequest.projectCreationRequestStatusId != 'REQUESTED' ||
      !((this.state.projectCreationRequest.projectCreationRequestId > 0 && this.state.projectCreationRequest.projectCreationRequestUsers.find(e => e.profileTypeRefId === "ADMIN" && e.user.mail === this.state.currentUser.email)) ||
        (this.state.projectCreationRequest.projectCreationRequestId === 0 && this.state.isUserDataScientist));
    const isCreate = this.state.projectCreationRequest.projectCreationRequestId === 0;

    if (this.state.isLoading) {
      return (
        <MainPagesLayout className='ProjectRequestCreation'>
          <ClassicTitledTile className="h3" title={(<h3>Request to a new project</h3>)}>
            <Loading />
          </ClassicTitledTile>
        </MainPagesLayout>
      );
    }

    return (
      <MainPagesLayout className='ProjectRequestCreation'>
        <ClassicTitledTile className="h3" title={(
          <h3>{this.state.isUserAdmin && !this.state.isUserDataScientist && this.state.projectCreationRequest.projectCreationRequestStatusId === 'REQUESTED' ? 'Validate project request' : 'Request a new project'}</h3>
        )}>
          <p>Before a very first creation, you should check that you have the sufficient rights to do so.
          Please send a mail to<span><a href="mailto:so-fran-codai_admin@suez.com"> so-fran-codai_admin@suez.com</a></span></p>

          <Form noValidate validated={this.state.formValidated} onSubmit={this.handleSubmit}>
            <Container>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Project Name</Form.Label>
                    <Form.Control
                      {...(readOnly && { readOnly: 'readOnly', disabled: 'disabled' })}
                      required
                      placeholder="Full Project Name"
                      aria-label="Project name"
                      value={this.state.projectCreationRequest.name}
                      onChange={(i) => this.updateProjectCreationRequest('name', i.target.value)}
                    />
                    <div className='formInputTextHelper'>Pick an explicit and precise name in English for your project. This field cannot be modified once the project is created.</div>
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Description for admins</Form.Label>
                    <Form.Control as="textarea"
                       rows={6}
                       style={{ height: '220px' }}
                      {...(readOnly && { readOnly: 'readOnly', disabled: 'disabled' })}
                      required
                      placeholder="Enter the project description here..."
                      aria-label="Description"
                      value={this.state.projectCreationRequest.description}
                      onChange={(i) => this.updateProjectCreationRequest('description', i.target.value)}
                      title="Only for validation step. Will be lost afterwards. &#13;Do not forget to fill markdown files after project creation"
                    />
                    <div className='formInputTextHelper'>Provide a macro description of your project in a couple of lines. This description will only be used for the validation of your project.</div>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Row>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label>Short Name</Form.Label>
                        <Form.Control
                          {...(this.state.invalidShortNameInput && { className: 'is-invalid' })}
                          {...(readOnly && { readOnly: 'readOnly', disabled: 'disabled' })}
                          required
                          placeholder="short-projname"
                          aria-label="Project short name"
                          minLength="5"
                          value={this.state.projectCreationRequest.shortName}
                          onChange={(i) => this.updateProjectCreationRequest('shortName', i.target.value)}
                        />
                        <div className='formInputTextHelper'>{'"a-z -", you need at least 5 characters and at most 12.'}</div>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Confidential</Form.Label>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          checked={this.state.projectCreationRequest.private ? 'checked' : ''}
                          onChange={() => this.updateProjectCreationRequest('private', !this.state.projectCreationRequest.private)}
                          label=""
                          title="A confidential project will not be displayed &#13;with full description in the portal"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Public</Form.Label>
                        <Form.Check
                          {...(readOnly && { disabled: 'disabled' })}
                          type="switch"
                          id="custom-switch1"
                          disabled={this.state.projectCreationRequest.private }
                          checked={this.state.projectCreationRequest.isPublic ? 'checked' : ''}
                          onChange={() => this.updateProjectCreationRequest('isPublic', !this.state.projectCreationRequest.isPublic)}
                          label=""
                          title="The code and datasets of public projects &#13;are accessible to anyone"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label>Cost Center</Form.Label>
                        <Form.Control
                          as="select"
                          {...(readOnly && { readOnly: 'readOnly', 'disabled': 'disabled' })}
                          required
                          value={this.state.projectCreationRequest.costcenterRefId}
                          onChange={(i) => this.updateProjectCreationRequest('costcenterRefId', i.target.value)}
                          title="The organization that will be &#13;billed for Azure Cloud costs"
                        >
                          <option key='empty'></option>
                          {this.state.availableCostCenters.map((c) => (
                            <option key={c.value} value={c.value}>{c.displayName}</option>
                          ))}
                        </Form.Control>
                        <div className='formInputTextHelper'>Select a cost center</div>
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label>Template</Form.Label>
                        <Form.Control
                          as="select"
                          {...(readOnly && { readOnly: 'readOnly', 'disabled': 'disabled' })}
                          value={this.state.projectCreationRequest.projectTemplateRefId}
                          onChange={(i) => this.updateProjectCreationRequest('projectTemplateRefId', i.target.value)}
                          required
                          title="Python ML is the most &#13;featured template"
                        >
                          {this.state.availableTemplates.map((c, i) => (
                            <option key={i} value={c.projectTemplateRefId}>{c.description}</option>
                          ))}
                        </Form.Control>
                        <div className='formInputTextHelper'>Select a template for your project.</div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="tagsCloudEditor">
                    <Row>
                      <Col sm={true}>
                        <Form.Label>Tags</Form.Label>
                        <TagListEditor
                          defaultValue={this.state.projectCreationRequest.projectCreationRequestTags}
                          availableTags={this.state.availableTags}
                          onChange={(tags) => this.onTagChange(tags)}
                          disable={readOnly}
                          required={true}
                        />
                        <div className='formInputTextHelper'>Add tags to help navigation to your project in the portal.</div>
                      </Col>
                    </Row>
                  </Form.Group>
                  <Row>
                    <Col md={3}>
                      <OverlayTrigger
                        key="enableWebapp"
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-enableWebapp`}>
                            The processing of the request requires a technical prerequisite with a set-up time of 48/72h                        </Tooltip>
                        }
                      >
                      <Form.Group>
                        <Form.Label>Web App</Form.Label>
                        <Form.Check
                          {...(readOnly && { disabled: 'disabled' })}
                          type="switch"
                          id="custom-switch2"
                          onChange={() => this.updateProjectCreationRequest('enableWebApp', !this.state.projectCreationRequest.enableWebApp)}
                          checked={this.state.projectCreationRequest.enableWebApp ? 'checked' : ''}
                          label=""
                        />
                        </Form.Group>
                      </OverlayTrigger>
                      <div className='formInputTextHelper'>Needed for having Rshiny/Streamlit/Flask webapp.</div>
                    </Col>
                    <Col md={3}  className={(this.state.projectCreationRequest.enableWebApp) ? "": "d-none"}  >
                      <Form.Group>
                        <Form.Label>Restrict Access</Form.Label>
                        <Form.Check
                          {...(readOnly && { disabled: 'disabled' })}
                          type="switch"
                          id="custom-switch4"
                          onChange={() => this.updateProjectCreationRequest('restrictAccessWebApp', !this.state.projectCreationRequest.restrictAccessWebApp)}
                          checked={this.state.projectCreationRequest.restrictAccessWebApp ? 'checked' : ''}
                          label=""
                          title="Restrict access to project members only"
                        />
                      </Form.Group>
                      <div className='formInputTextHelper'>Restrict access to project members only.</div>

                    </Col>
                    <Col md={3}>
                      <OverlayTrigger
                        key="enableDocumentation"
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-enableDocumentation`}>
                            The processing of the request requires a technical prerequisite with a set-up time of 48/72h                        </Tooltip>
                        }
                      >
                      <Form.Group>
                        <Form.Label>Documentation</Form.Label>
                        <Form.Check
                          {...(readOnly && { disabled: 'disabled' })}
                          type="switch"
                          id="custom-switch3"
                          onChange={() => this.updateProjectCreationRequest('enableDocumentation', !this.state.projectCreationRequest.enableDocumentation)}
                          checked={this.state.projectCreationRequest.enableDocumentation ? 'checked' : ''}
                          label=""
                          />
                        </Form.Group>
                      </OverlayTrigger>
                      <div className='formInputTextHelper'>Provides a website to browse the documentation.</div>
                    </Col>
                    <Col md={3}  className={(this.state.projectCreationRequest.enableDocumentation) ? "": "d-none"}>
                      <Form.Group>
                        <Form.Label>Restrict Access</Form.Label>
                        <Form.Check
                          {...(readOnly && { disabled: 'disabled' })}
                          type="switch"
                          id="custom-switch5"
                          onChange={() => this.updateProjectCreationRequest('restrictAccessDocumentation', !this.state.projectCreationRequest.restrictAccessDocumentation)}
                          checked={this.state.projectCreationRequest.restrictAccessDocumentation ? 'checked' : ''}
                          label=""
                          title="Restrict access to project members only"
                        />
                      </Form.Group>
                      <div className='formInputTextHelper'>Restrict access to project members only.</div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col md={true}>
                  <Form.Group className="projectUserListInput" title="Add team members. &#13;You will be allowed to modify team structure during project lifetime. &#13;Product owner won’t have write access to code repos.">
                    <Form.Label>Team</Form.Label>
                    <UserListEditor
                      ref={e => this.usersListEditorRef = e}
                      value={this.state.projectCreationRequest.projectCreationRequestUsers}
                      availableRoles={this.state.availableRoles}
                      onChange={this.updateMember}
                      protectAdmin={true}
                      disable={readOnly}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col sm={true} />
                <div>
                  <Button variant="outline-primary" onClick={() => this.cancelProjectCreationRequest()}>
                    {(this.state.projectCreationRequest.projectCreationRequestStatusId != 'REQUESTED' ||
                      this.state.projectCreationRequest.projectCreationRequestId === 0)
                      ? 'Close' : 'Cancel'
                    }
                  </Button>
                  {' '}
                  {this.state.isUserDataScientist && this.state.projectCreationRequest.projectCreationRequestStatusId === 'REQUESTED' && (
                    (isCreate ? (
                      <Button type="submit" variant="primary">{this.state.buttonTextCreate}</Button>
                    ) : (!readOnly && (
                      <Button type="submit" variant="primary">{this.state.buttonTextUpdate}</Button>
                    )
                    )))}
                  {!isCreate && this.state.projectCreationRequest.projectCreationRequestStatusId === 'REQUESTED' && this.state.isUserAdmin && (
                    <Button variant="primary" onClick={this.validateProjectRequest}>{this.state.buttonTextValidate}</Button>
                  )}
                  {this.state.projectCreationRequest.projectCreationRequestStatusId != 'REQUESTED' && (
                    <b className="projectRequestStatusText">{this.state.projectCreationRequest.projectCreationRequestStatus.projectCreationRequestStatusDescription}</b>
                  )}
                </div>
                <Col sm={true} />
              </Row>
            </Container>
          </Form>
        </ClassicTitledTile>
      </MainPagesLayout>
    );
  }
}

export default ProjectRequestCreationPage;
